module.exports = __webpack_public_path__ + "static/media/sticker-image-3.24c2cf57.png";